import { config } from "../../Config";

const SearchUsers = async (query, { excludeId = "", limit = 10, signal } = {}) => {
  if (!query || query.trim().length < 2) {
    return { success: true, users: [] };
  }

  const baseUrl = config.searchUsers;
  if (!baseUrl) {
    return { success: false, error: "searchUsers endpoint not configured", users: [] };
  }

  const url = new URL(baseUrl);
  url.searchParams.set("q", query.trim());
  url.searchParams.set("limit", String(limit));
  if (excludeId) url.searchParams.set("excludeId", excludeId);

  try {
    const response = await fetch(url.toString(), { method: "GET", signal });
    if (!response.ok) {
      const errorBody = await response.text().catch(() => "");
      return {
        success: false,
        error: `SearchUsers failed (${response.status}): ${errorBody}`,
        users: [],
      };
    }
    const data = await response.json();
    return { success: true, users: Array.isArray(data.users) ? data.users : [] };
  } catch (error) {
    if (error.name === "AbortError") {
      return { success: false, aborted: true, users: [] };
    }
    return { success: false, error: error.message, users: [] };
  }
};

export default SearchUsers;
